module.exports = __webpack_public_path__ + "img/video-active.235e0598.png";